/**
 * Append CDN resize/quality params to a bartacdn image URL.
 * Falls through gracefully for null/non-CDN URLs.
 */
export function cdnImage(
  url: string | null | undefined,
  opts: { w?: number; h?: number; q?: number; fmt?: string } = {},
): string | null {
  if (!url) return null
  try {
    const u = new URL(url)
    if (opts.w) u.searchParams.set('w', String(opts.w))
    if (opts.h) u.searchParams.set('h', String(opts.h))
    u.searchParams.set('q', String(opts.q ?? 75))
    u.searchParams.set('fmt', opts.fmt ?? 'webp')
    return u.toString()
  } catch {
    return url
  }
}
